import React from 'react';
import AuthService from './authService';
import fileHelper from '../Helpers/fileHelper';
import SearchParams from '../Elements/SearchParams';
import TemplateGroupItem from '../Domain/Template/TemplateGroupItem';
import TemplateVariantItem from '../Domain/Template/TemplateVariantItem';
import TemplateGroupSearchParams from '../Contents/Administration/Templates/TemplateGroupSearchParams';
import TemplateVariantSearchParams from '../Contents/Administration/Templates/TemplateVariantSearchParams';

export default class TemplateService extends React.Component {
  static GetTemplateGroupsBySearching(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(
      searchItem,
      TemplateGroupSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    const url = `/api/Template/GetTemplateGroups/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBGroupItems(items) {
    const convertedItems = [];
    if (items !== null && items !== undefined) {
      items.forEach((item) => convertedItems.push(new TemplateGroupItem(item)));
    }
    return convertedItems;
  }

  static GetTemplateVariantsBySearching(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(
      searchItem,
      TemplateVariantSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    const url = `/api/Template/GetTemplateVariants/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBVariantItems(items) {
    const convertedItems = [];
    if (items !== null && items !== undefined) {
      items.forEach((item) => convertedItems.push(new TemplateVariantItem(item)));
    }
    return convertedItems;
  }

  // Answers with { binaryContent (base64), name, type } for fileHelper.saveBase64File. The same
  // endpoint also answers by name, which is what a report page's "Download Template" uses.
  static GetTemplateById(templateId) {
    return AuthService.getInstance().CallBackendFunction(`/api/Template/GetTemplate?templateId=${templateId}`);
  }

  // MUST return the promise (wizard contract). The file rides under the key 'file', which is what
  // AuthService's 25 MB check looks at. Description and IsStringContent only count for a new name.
  static CreateTemplate(edited) {
    const data = new FormData();
    data.append('file', edited.SelectedFile);
    data.append('Name', edited.Name ?? '');
    data.append('Description', edited.Description ?? '');
    data.append('Locale', edited.Locale ?? '');
    data.append('IsStringContent', (edited.IsStringContent === true).toString());
    return AuthService.getInstance().CallBackendFunctionPostFile('/api/Template/CreateTemplate', data);
  }

  // The only edit there is, and it reaches every language and version of the name
  static UpdateTemplateGroup(edited) {
    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/Template/UpdateTemplateGroup',
      JSON.stringify(edited)
    );
  }

  // The variant is named, not identified by its id: the backend stores the file on top of whatever
  // the newest version of that template + language is when the upload arrives, so a list that has
  // gone stale in the meantime cannot aim at a superseded row.
  static UploadTemplateVersion(edited) {
    const data = new FormData();
    data.append('file', edited.SelectedFile);
    data.append('Name', edited.Name ?? '');
    data.append('Locale', edited.Locale ?? '');
    return AuthService.getInstance().CallBackendFunctionPostFile('/api/Template/UploadTemplateVersion', data);
  }

  /**
   * Stores edited text as the next version of a variant. There is no separate endpoint for it: the
   * text becomes a file named after the template, so this is the same upload the file picker does —
   * which is also what keeps the stored bytes identical to a download-edit-re-upload round trip.
   *
   * @param {object} item the variant being edited (Name, Locale and Type are read)
   * @param {string} text the content to store
   */
  static SaveTemplateContent(item, text) {
    const fileName = `${item.Name}.${(item.Type ?? '').toLowerCase()}`;
    return TemplateService.UploadTemplateVersion({
      Name: item.Name,
      Locale: item.Locale,
      SelectedFile: fileHelper.textAsFile(text, fileName, 'text/plain'),
    });
  }
}
